import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography
} from '@mui/material';
import React, { FormEvent, useState } from 'react';
import { cancelButtonStyle, saveButtonStyle } from '../../../style';
import { useScreenSmallerThan } from '../../../lib/hooks/breakpoint-hooks';

interface ModalProps {
    id: string;
    onDeleteAncillaryHour: (event: FormEvent, id: string) => void;
}

const DeleteAncillaryHourModal = ({ id, onDeleteAncillaryHour }: ModalProps) => {
    const isSmallerThanSmall = useScreenSmallerThan('sm');
    const [isDialogOpened, setDialogOpened] = useState(false);
    const handleCloseDialog = () => setDialogOpened(false);
    const handleOpenDialog = () => setDialogOpened(true);

    const handleSave = async (event: FormEvent) => {
        onDeleteAncillaryHour(event, id);

        //Close Dialog window
        setDialogOpened(false);
    };

    return (
        <>
            <IconButton aria-label="delete" onClick={handleOpenDialog} disableRipple={true}>
                <DeleteOutlined />
                {isSmallerThanSmall && <Typography pl={'0.525rem'}>Delete</Typography>}
            </IconButton>
            <Dialog open={isDialogOpened} onClose={handleCloseDialog}>
                <DialogTitle variant="h3">Remove Time</DialogTitle>
                <DialogContent>
                    <Typography variant="h4">Are you sure you want to delete this item?</Typography>
                </DialogContent>
                <DialogActions sx={{ paddingRight: '1.5rem', paddingLeft: '1.5rem' }}>
                    <Button sx={cancelButtonStyle} onClick={handleCloseDialog}>
                        Cancel
                    </Button>
                    <Button sx={saveButtonStyle} onClick={handleSave}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default DeleteAncillaryHourModal;
